import React, { useEffect } from "react"
import ListDays from "../components/elements/ListDays"
import Fruchtgummi from "../components/Fruchtgummi"
import { updateIframeHeight, updateIframeScrollTo } from "../helper"
import PromoSoonOverHandler from "../components/PromoSoonOverHandler"

const Lose: React.FC = () => {
	useEffect(() => {
		updateIframeScrollTo(0)
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})

		updateIframeHeight()

		setTimeout(() => updateIframeHeight(), 1000)
		// eslint-disable-next-line
	}, [])

	return (
		<PromoSoonOverHandler>
			<div className="contentGradient ">
				<div className="container text-center py-12">
					<h1 className="h1">DU HAST LEIDER NICHT GEWONNEN</h1>
					<h2 className="h3 py-6">Versuch‘s später oder an einem anderen Wochentag noch einmal!</h2>
					<a href="/" className="btn inline-block mt-8">
						zurück
					</a>
					<div className="pt-12 pb-12">
						<ListDays />
					</div>
					<a href="https://www.nimm2.de/de/ideen-inspirationen" target="_parent" rel="noopener noreferrer">
						<button className="btn ">Entdecke Basteltipps und vieles mehr</button>
					</a>
				</div>
				<Fruchtgummi />
			</div>
		</PromoSoonOverHandler>
	)
}
export default Lose
